import createClient from '../../helpers/api-client';

import { FETCH_FILTERS } from './filters-model';

const storeSuffix = 'SearchProfile';

// ACTIONS
export const FETCH_SEARCH_PROFILE = `fetchSearchProfileAction${storeSuffix}`;
export const SAVE_SEARCH_PROFILE = `saveSearchProfileAction${storeSuffix}`;

// MUTATIONS
export const BEGIN_FETCH = `beginFetchMutation${storeSuffix}`;
export const FETCH_COMPLETED = `fetchCompletedMutation${storeSuffix}`;
export const FETCH_FAILED = `fetchFailedMutation${storeSuffix}`;
export const UPDATE_CATEGORIES = `updateCategoriesMutation${storeSuffix}`;
export const UPDATE_REGIONS = `updateRegionsMutation${storeSuffix}`;

// GETTERS
export const IS_LOADING = `getIsLoadingGetter${storeSuffix}`;
export const GET_ERROR = `getErrorGetter${storeSuffix}`;
export const GET_SEARCH_PROFILE = `getSearchProfileGetter${storeSuffix}`;

export const modelState = () => ({
    searchProfile: {
        isLoading: false,
        error: null,
        data: {},
    },
});

export const actions = {
    [FETCH_SEARCH_PROFILE]: ({ state, commit, dispatch }) => {
        return new Promise(async (resolve, reject) => {
            await dispatch(FETCH_FILTERS);

            const apiClient = createClient(state);

            commit(BEGIN_FETCH);
            try {
                const response = await apiClient.get(
                    `/api/my-pages/company/search-profile`
                );
                commit(FETCH_COMPLETED, response);
                resolve(response);
            } catch (error) {
                commit(FETCH_FAILED);
                reject(error);
            }
        });
    },
    [SAVE_SEARCH_PROFILE]: ({ state }) => {
        return new Promise(async (resolve, reject) => {
            // Här ska vi egentligen göra allt vi behöver göra för att faktiskt spara profilen.
            // Det enda vi eventuellt behöver commita till state är om vi får tillbaka uppdaterat objekt vid success. Men det är egentligen överflödigt.
            // I övrigt räcker det med att vi resolve:ar eller reject:ar. Datan lever i store:en tills appen laddas om.
            const apiClient = createClient(state);

            try {
                const response = await apiClient.post(
                    `/api/my-pages/company/search-profile`,
                    state.searchProfile.data
                );
                resolve(response);
            } catch (error) {
                reject(error);
            }
        });
    },
};

export const mutations = {
    [BEGIN_FETCH]: state => {
        state.searchProfile.isLoading = true;
        state.searchProfile.error = false;
    },
    [FETCH_COMPLETED]: (state, payload) => {
        const { data } = payload;
        state.searchProfile.isLoading = false;
        state.searchProfile.error = false;
        state.searchProfile.data = data;
    },
    [FETCH_FAILED]: state => {
        state.searchProfile.isLoading = false;
        state.searchProfile.error = true;
    },
    [UPDATE_CATEGORIES]: (state, payload) => {
        state.searchProfile.data.Categories = payload;
    },
    [UPDATE_REGIONS]: (state, payload) => {
        state.searchProfile.data.Regions = payload;
    },
};

export const getters = {
    [IS_LOADING]: state => {
        return state.searchProfile.isLoading;
    },
    [GET_ERROR]: state => {
        return state.searchProfile.error;
    },
    [GET_SEARCH_PROFILE]: state => {
        return state.searchProfile.data;
    },
};



// WEBPACK FOOTER //
// ./src/store/store-models/search-profile-model.js